// Action types for the AI reply agent, inbox drafts and Tavus avatars.
// Every async action has matching _SUCCESS and _FAILURE types so loading and
// in-flight state is always cleared.
type AsyncTypes<T extends string> = { [K in T | `${T}_SUCCESS` | `${T}_FAILURE`]: K };

const asyncTypes = <T extends string>(name: T) =>
  ({
    [name]: name,
    [`${name}_SUCCESS`]: `${name}_SUCCESS`,
    [`${name}_FAILURE`]: `${name}_FAILURE`,
  } as AsyncTypes<T>);

export const types = {
  ...asyncTypes("GET_AGENT"),
  ...asyncTypes("UPDATE_AGENT"),
  ...asyncTypes("ADD_AGENT_EXAMPLE"),
  ...asyncTypes("REMOVE_AGENT_EXAMPLE"),
  ...asyncTypes("TEST_AGENT"),
  CLEAR_AGENT_TEST: "CLEAR_AGENT_TEST" as const,
  ...asyncTypes("GET_INBOX_MESSAGES"),
  ...asyncTypes("GET_DRAFT_STATS"),
  ...asyncTypes("GENERATE_DRAFT"),
  // 202 from POST /ai/drafts/generate: the draft is written in the background.
  GENERATE_DRAFT_QUEUED: "GENERATE_DRAFT_QUEUED" as const,
  ...asyncTypes("FETCH_DRAFT"),
  ...asyncTypes("UPDATE_DRAFT_BODY"),
  ...asyncTypes("DECIDE_DRAFT"),
  ...asyncTypes("SEND_DRAFT"),
  ...asyncTypes("CREATE_DRAFT_VIDEO"),
  ...asyncTypes("GET_WATCH"),
  ...asyncTypes("START_WATCH"),
  ...asyncTypes("STOP_WATCH"),
  ...asyncTypes("GET_AVATARS"),
  ...asyncTypes("GET_STOCK_FACES"),
  ...asyncTypes("CREATE_AVATAR"),
  ...asyncTypes("SYNC_AVATAR"),
  ...asyncTypes("SET_DEFAULT_AVATAR"),
  ...asyncTypes("DELETE_AVATAR"),
};
